import React, { useMemo } from 'react';
import FormInput from 'components/Input/FormInput';
import { Rule } from 'antd/lib/form';
import { useTranslation } from 'react-i18next';

interface IVersionOfFirmwareInput {
	changeVersionOfFirmware: (value: string) => void;
}

const VersionOfFirmwareInput: React.FC<IVersionOfFirmwareInput> = ({ changeVersionOfFirmware }) => {
	const { t } = useTranslation('error');
	const { t: tForm } = useTranslation('form');

	const validationRules = useMemo<Rule[]>(
		() => [
			{ required: true, message: t('enterFirmwareVersion') },
			{ max: 50, message: tForm('fieldCannotBeMoreThanCharactersLong', { count: 50 }) },
		],
		[t],
	);

	return (
		<FormInput
			testId="VersionOfFirmwareInput"
			name="versionOfFirmware"
			label="versionLabel"
			onChange={changeVersionOfFirmware}
			validationRules={validationRules}
		/>
	);
};

export default React.memo(VersionOfFirmwareInput);
